
import news from '../../api/news'



export default {
    data(){
        return {
            tabs : [
                {
                    type : 1,
                    name : '公司动态'
                },
                {
                    type : 2,
                    name : '行业新闻'
                },
                {
                    type : 3,
                    name : '技术交流'
                },
            ],
            cate : [
                {
                    type : 0,
                    name : '全部',
                    id : 0
                },
                {
                    type : 1,
                    name : '近一个月',
                    id : 30
                },
                {
                    type : 2,
                    name : '2019',
                    id : 2019
                },
                {
                    type : 2,
                    name : '2018',
                    id : 2018
                },
            ],
            active : 0 ,    //一级分类
            cate_active : 0, //二级时间分类
            page : 1 ,      
            pageSize : 5 ,
            pagelength : 10 ,
            newsList : [] , //新闻所有数据
            mapNews : {} , //映射分类数据 
            busy : false,
            timePost : {
                dateFilter : 0,
                timeState : 0
            },
            loading : true
        }
    },
    created(){
        this.getNewsList();
        this.typeTime()
    },
    methods : {
        getNewsList(bool){
            let {page,pageSize,active , newsList,timePost} = this;
            news.getPageNews({
                page : page ,
                pageSize : pageSize,
                typeId : active,
                ...timePost
            }).then(res=>{
                bool ? this.newsList = newsList.concat(res.pageList) : 
                this.newsList = res.pageList;
                this.pagelength = res.total
                this.loading = false
            }).catch(()=>{
                this.loading = false
            })
            this.page++;
        },
        tabChange(e){
            if(this.active == e) return ;
            this.active = e ;
            this.page = 1;
            this.newsList = []
            this.loading = true
            this.getNewsList();
        },
        tabTime(e,i){
            if(e == this.cate_active) return;
            this.loading = true
            let {cate} = this;
            this.cate_active = e;
            this.page = 1
            this.newsList = []
            this.timePost = {
                dateFilter : cate[i].time,
                timeState : cate[i].type
            }
            this.getNewsList();
        },
        pagenext(){
            if(this.page >= this.pagelength) return;
            this.page +=1;
        },
        mapList(){
        },
        pageActive(e){
            this.page = e;
            this.getNewsList();
        },
        infinite(){
            this.getNewsList(true)
            this.$refs.myscroller.finishInfinite(true)
        },

        // 时间转换
        typeTime(){
            let {cate} = this;
            
            let mapCate =  cate.map(item=>{
                let t = new Date();
                let iToDay=t.getDate();
                let iToMon=t.getMonth();
                let iToYear=t.getFullYear();
                let newDate;
                let time;
                if(item.id > 12 && item.id < 366){
                    // 天
                    newDate = new Date(iToYear,iToMon+1,iToDay-item.id)
                    let y = newDate.getMonth();
                    if(y<10){
                        y = '0'+y
                    }
                    time = `${newDate.getFullYear()}-${y}-${newDate.getDate()}`
                }else if(item.id > 1000 ){
                    // 年
                    time = item.id
                }else{
                    time = 0
                }

                return {
                    ...item,
                    time
                }
            })
            this.cate = mapCate

        }
    },

    watch:{

    }

}